<div class="modal-body text-center">
    <h5 *ngIf="title">{{ title }}</h5>
</div>
<div class="modal-content">
    <form
        action="#"
        autocomplete="off"
        (ngSubmit)="onSubmit()"
        [formGroup]="form"
    >
        <div class="form-modal px-4">
            <div class="w-100">
                <app-select
                    id="doctor"
                    name="doctor"
                    [options]="doctors"
                    labelName="Selecione o médico"
                    placeholder="Selecione o médico"
                    [form]="form"
                    [inputModel]="''"
                ></app-select>
            </div>
        </div>
        <div class="modal-footer">
            <button
                type="button"
                class="btn outline"
                (click)="close()"
                [disabled]="loading"
            >
                Cancelar
            </button>
            <button
                type="submit"
                class="btn btn-xs"
                [disabled]="loading"
            >
                Enviar
            </button>
        </div>
    </form>
</div>
